import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=0a637ff6&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=ts&"
export * from "./ReviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=0a637ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a637ff6",
  null
  
)

export default component.exports